import gql from 'graphql-tag';

export const NotifyParticipantDocumentAuthors = gql`
  mutation NotifyParticipantDocumentAuthors(
    $organizationId: ID!
    $participantId: ID!
    $participantDocumentId: ID!
    $userId: ID!
  ) {
    notifyParticipantDocumentAuthors(
      organizationId: $organizationId
      participantId: $participantId
      participantDocumentId: $participantDocumentId
      userId: $userId
    )
  }
`;
